<template>
  <!-- -->
  <yq-table :data="data" height="100%" stripe border page-name="laborersList">
    <yq-table-column label="姓名" prop="contractName"/>
    <yq-table-column label="性别" prop="contractSex">
      <template v-slot="{row}">
        <span v-if="row.contractSex === '1'">男</span>
        <span v-if="row.contractSex === '2'">女</span>
      </template>
    </yq-table-column>
    <yq-table-column label="年龄" prop="contractAge"/>
    <yq-table-column label="住址" prop="address" :show-overflow-tooltip="true" />
    <yq-table-column label="手机号" prop="phone"/>
    <yq-table-column label="身份证号" prop="cardNo" :show-overflow-tooltip="true"/>
    <yq-table-column label="工种" prop="jobCategory">
      <template v-slot="{row}">
        <c-custom-select value="dictCode" label="dictName"
                         :data-list="jobCategoryList" v-model="row.jobCategory" :read-only="true"/>
      </template>
    </yq-table-column>
    <yq-table-column label="施工班组" prop="classmateId" :show-overflow-tooltip="true">
      <template v-slot="{row}">
        {{ getClassmateLot(row.classmateId) }}
      </template>
    </yq-table-column>
    <yq-table-column label="标段" prop="lot" v-if="lotList.length > 0">
      <template #default="{row}">
              <span v-for="item in lotList" :key="item.id">
                <span v-if="item.dictCode === row.lot">{{item.dictName}}</span>
              </span>
      </template>
    </yq-table-column>
    <yq-table-column label="所属工地" prop="siteName">
      <template v-slot="{row}">
<!--        <c-custom-select value="id" label="siteName"-->
<!--                         :data-list="siteList" v-model="row.siteId" :read-only="true"/>-->
      </template>
    </yq-table-column>
    <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem"
                     :show-overflow-tooltip="false">
      <template v-slot="{row}">
        <table-button-group label="更多操作">
          <table-button hasAnyPerms="laborers:list:save" @click="toEdit(row)">编辑</table-button>
          <table-button hasAnyPerms="laborers:list:history" @click="toShowHistory(row.id)">履历</table-button>
          <table-button hasAnyPerms="laborers:list:remove" el-type="danger" message="是否确认删除数据" @click="deleteRow(row.id)">删除</table-button>
        </table-button-group>
      </template>
    </yq-table-column>
  </yq-table>
  <data-history ref="dataHistory" :data-list="historyList" title="人员履历">
    <template #name="{row}">
      <div v-if="row.historyType === 'BLACK_ADD'">加入黑名单</div>
      <div v-if="row.historyType === 'BLACK_LEAVE'">移除黑名单</div>
      <div v-if="row.historyType === 'WORKER_ADD'">添加入档</div>
      <div v-if="row.historyType === 'SAFE_EDUCATION'">安全教育</div>
      <div v-if="row.historyType === 'SITE_DISPATCH'">派遣至工地[{{row.siteName}}]</div>
    </template>
    <template #info></template>
    <template #option="{row}">操作人：{{row.operateName ? row.operateName : '第三方设备操作'}}</template>
  </data-history>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import Util from "@/util/util";
import commonApi from "@/api/commonApi";
import contractWorkersApi from "@/api/dz-luqiao/luqiaoContractWorkersApi";
import DataHistory from "@/components/h5/data/DataHistory.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";
export default {
  props: {
    data: {default: () => []},
    lotList: {default: () => []}
  },
  emits: ['dataUpdate'],
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "LaborersTable",
  components: {YqTableColumn, DataHistory, CCustomSelect},
  data() {
    return {
      siteList: [],
      projectList: [],
      classmateList: [],
      jobCategoryList: [],
      historyList: [] ,
    };
  },
  async created() {
    // 查询工地
    this.projectList = await commonLqApi.queryProjectNoPage()
    // 查询项目
    this.siteList = await commonLqApi.querySiteNoPage()
    // 施工班组
    this.classmateList = await commonLqApi.queryClassmateNoPage()
    // 工种列表
    const user = await Util.getUserInfo()
    this.jobCategoryList = await commonApi.queryDictionaryList("JOB_CATEGORY", user.merchantId)
  },
  computed: {
    getMath() {
      // 获取1-11随机整数
      // return Math.floor(Math.random() * 11) + 1
      return 3
    },

  },
  methods: {
    toEdit(data) {
      this.router.push(`/laborers/list/detail?id=${data.id}`);
    },
    getClassmateLot(id){
      const classmate = this.classmateList.find(c => c.id === id)
      if (!classmate) {
        return ''
      }
      return classmate.classmateName + '(' + classmate.lotName + ')'
    },
    /**
     * 删除行
     * @param id
     */
    async deleteRow(id){
      await contractWorkersApi.delete(id)
      // 通过 splice 清空并重新填充数组
      this.$emit('dataUpdate')
    },
    async toShowHistory(id){
      this.historyList = await contractWorkersApi.queryWorkerHistory(id)
      this.$refs.dataHistory.showData();
    },
    getColor(type) {
      type = Number(type)
      switch (type) {
        case 1:
          return '#FF4D4F'  // 红色 - 玫瑰红
        case 2:
          return '#52C41A'  // 绿色 - 翠绿
        case 3:
          return '#1890FF'  // 蓝色 - 天蓝
        case 4:
          return '#FAAD14'  // 黄色 - 金盏花黄
        case 5:
          return '#FA8C16'  // 橙色 - 橙红
        case 6:
          return '#722ED1'  // 紫色 - 紫罗兰
        case 7:
          return '#EB2F96'  // 粉色 - 品红
        case 8:
          return '#13C2C2'  // 青色 - 孔雀蓝
        case 9:
          return '#EB2F96'  // 玫红色 - 洋红
        case 10:
          return '#76f6ae'  // 浅绿色
        default:
          return '#000000'  // 黑色
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.timeline-box {
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none; /* 针对 Webkit 内核浏览器隐藏滚动条 */
  }

  -ms-overflow-style: none; /* 针对 IE 和 Edge 隐藏滚动条 */
  scrollbar-width: none; /* 针对 Firefox 隐藏滚动条 */
}
</style>